"use client";
import { useState } from 'react';

export default function ForgotPassword() {

    const baseURL = process.env.NEXT_PUBLIC_BASE_URL;
    const [loading, setLoading] = useState(false);

    const [status, setStatus] = useState('');

    async function handleSubmit(e) {
        e.preventDefault();
        setLoading(true);
        const user = e.target.login.value;

        try {
            const res = await fetch(
                `${baseURL}api/account/v1/forgot-password`,
                {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ login: user })
                }
            );

            const err = await res.json();

            if (res.ok) {
                setStatus('تحقق من استلام الرابط في بردك الإلكتروني.');
            } else {
                setStatus('حدث خطأ ما، حاول مرة أخرى، في حال استمرار المشكلة تواصل معنا عبر البريد الإلكتروني. <a href="mailto: support@figmawya.com">support@figmawya.com</a>');
            }
        } catch (err) {
            // setStatus(err?.message || 'حدث خطأ ما، حاول مرة أخرى.');
            setStatus(err?.message);
            // setStatus(err?.status + 'حدث خطأ ما، حاول مرة أخرى، في حال استمرار المشكلة تواصل معنا عبر البريد الإلكتروني. <a href="mailto: support@figmawya.com">support@figmawya.com</a>');
        } finally {
            setLoading(false);
        }
    }

    return (
        <form onSubmit={handleSubmit} className='container col-12 col-md-6 max-w-xl mx-auto p-4 bg-white rounded-4'>
            <h2 className='mb-4'>نسيت كلمة المرور</h2>
            <div className="row">
                <fieldset className='col-12 col-md-6'>
                    <label className='form-label w-100'>
                        اسم المستخدم أو البريد الإلكتروني:</label>
                    <input name="login" className='form-control' type="text" required />
                </fieldset>
            </div>
            {status && !loading && <p className='mt-2 alert alert-info'>{status}</p>}
            <button className='btn btn-primary mt-2' type="submit" disabled={loading}>
                {loading ? 'جار التحقق من البيانات ...' : ' إرسال رابط إعادة تعيين كلمة المرور'}
            </button>
        </form>
    );
}